

import { Component, Vue } from "vue-property-decorator";
import ParticaBaseView from "./ParticaBaseView.vue";
import { BreadcrumbItem } from "../../Models/Breadcrumb";

@Component({
	name: "ParticaStreamBase"
})
export default class ParticaStreamBase extends ParticaBaseView {
	protected navAccountId: number = 0;
	protected metadata: any = { page: "stream", name: "" };

	protected async getStreamNav(id: number) {
		let title: string = "";
		this.navData = await this.navigationService.GetNavData(id, this.metadata.page, this.stateconfig.accountid);
		if (this.navData !== undefined) {

			if (this.navData.parentName !== null && this.navData.parentName !== undefined) {
				title += " : " + this.navData.parentName;
			}
			if (this.navData.name !== null && this.navData.name !== undefined) {
				title += " : " + this.navData.name;
			}
		}
		this.setPageTitle(title);
		this.breadcrumbs = [
			{ text: this.navData.parentName, to: `/${this.navData.parentId}/home/`, exact: true } as BreadcrumbItem,
			{ text: "Streams", to: `/${this.navData.parentId}/contentstreams/`, exact: true } as BreadcrumbItem,
			{ text: this.navData.name, to: `/contentstream/${this.navData.id}/`, exact: true } as BreadcrumbItem,
			{ text: this.metadata.name, to: ``, disabled: true, exact: true } as BreadcrumbItem
		];
	}
}
